// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error#ES6_Custom_Error_Class

class StatusError extends Error {
	constructor(status, ...params) {
		super(...params);
		// Maintains proper stack trace for where our error was thrown (only available on V8)
		if (Error.captureStackTrace) {
			Error.captureStackTrace(this, StatusError);
		}
		this.name = 'StatusError';
		this.status = status;
	}
}

export default StatusError;
